module.exports = __webpack_public_path__ + "assets/coins-f8d6df.svg";